import {
  UPDATE_PRIMARY_FOOTER,
  SET_HEADER_CLOSE,
  CLEAR_CONFIRMATION,
  UPDATE_CONFIRMATION_SUCCESS,
  HIDE_OVERLAY,
  SHOW_OVERLAY,
} from '../Types';

const initialState = {
  footerContent: {
    content: null,
    isLoaded: false,
  },
  onHeaderClose: null,
  isConfirmSuccess: false,
  confirmationMsg: '',
  showOverlay: false,
  overlayMessage: '',
  showOverlayLoader: false,
};

export const pageLayout = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PRIMARY_FOOTER:
      return {
        ...state,
        footerContent: {
          content: action.content,
          isLoaded: true,
        },
      };
    case SET_HEADER_CLOSE:
      return { ...state, onHeaderClose: action.payload };
    case UPDATE_CONFIRMATION_SUCCESS:
      return { ...state, isConfirmSuccess: true, confirmationMsg: action.msg };
    case CLEAR_CONFIRMATION:
      return { ...state, isConfirmSuccess: false, confirmationMsg: '' };
    case SHOW_OVERLAY:
      return { ...state, showOverlay: true, overlayMessage: action.message, showOverlayLoader: action.showLoader };
    case HIDE_OVERLAY:
      return { ...state, showOverlay: false, overlayMessage: '', showOverlayLoader: false };
    default:
      return state;
  }
};
